import React, { useContext, useState } from "react"
import KidsLayout from "./../../components/kidslayout"
import ContentSection from "./../../components/ChildHome/ContentSection/ContentSection"
import KidsLogin from "./../../components/KidsLogin/KidsLogin"
import BannerImage from './../../images/KidsHomepageBanner.png'
import JoinSection from "../../components/ChildHome/JoinSection/JoinSection"


// markup
const Kids = ({ data }) => {
	return(
		<KidsLayout title="Kids Homepage">
			<section className="kids-page">
				<section className="hero-banner">
					<div className="hero-wrapper">
						<div className="image-wrapper">
							<img src={BannerImage} className="" alt="Banner Image"/>
						</div>
						<div className="container-fluid">
							<div className="row justify-content-end">
								<div className="col-12 col-lg-6 banner-sidebar">
									<div className="text-wrapper">
										<KidsLogin />
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<ContentSection />
				<JoinSection/>
			</section>
		</KidsLayout>
	)
}

export default Kids
